import React from 'react'
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { Modal, Form, Button } from "react-bootstrap";
const DailyLimitTypeDialog = (props) => {
    const {
        onClose,
        value: valueProp,
        open,
        playerList,
        ...other
    } = props;
    const [value, setValue] = React.useState(valueProp);

    React.useEffect(() => {
        if (!open) {
            setValue(valueProp);
        }
    }, [valueProp, open]);

    const handleCancel = () => {
        onClose();
    };

    const handleOk = () => {
        onClose(value);
    };


    const handleChange = (event) => {
        setValue(event.target.value);
    };
    return (
        <Dialog
            sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
            maxWidth="xs"
            open={open}
            {...other}
        >
            <DialogTitle>Day Limit </DialogTitle>
            <DialogContent dividers>

                <FormControl style={{ width: "100%", marginTop: "20px" }}>
                    <TextField
                        id="outlined-basic"
                        label="Day Limit"
                        variant="outlined"
                        value={value}
                        onChange={handleChange}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleCancel}>
                    Cancel
                </Button>
                <Button onClick={handleOk}>Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DailyLimitTypeDialog